module.exports = __webpack_public_path__ + "static/media/img13.dec71a7a.jpg";